import { render, staticRenderFns } from "./babyFeedDetails.vue?vue&type=template&id=4ef18bd9&scoped=true"
import script from "./babyFeedDetails.vue?vue&type=script&lang=js"
export * from "./babyFeedDetails.vue?vue&type=script&lang=js"
import style0 from "./babyFeedDetails.vue?vue&type=style&index=0&id=4ef18bd9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef18bd9",
  null
  
)

export default component.exports